module.exports = __webpack_public_path__ + "static/depoimento 3-f3f762f5983b06847068457336184eed.svg";